import React from "react";

export default function ExpandToolBoxButton() {
  return (
    <svg width="44" height="35" viewBox="0 0 44 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23 12.5H32V14.5H23V12.5ZM23 20.5H32V22.5H23V20.5ZM26 16.5H32V18.5H26V16.5ZM23 17.5L18 12.5V16.5H12V18.5H18V22.5L23 17.5Z"
        fill="#002035"
      />
      <rect x="0.5" y="0.5" width="43" height="34" rx="9.5" stroke="#002035" />
    </svg>
  );
}
